/****************************************************
 * Module Name:  stoneProxy.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import restAPICall from "../../api/restAPICall";
import Constants from "../../constants";

export default class StoneProxy {
  static GetAllStone = (callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/stone",
      "get",
      Constants.userToken,
      undefined,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetSingleStone = (stoneId, callback) => {
    let params = {
      id: stoneId,
    };

    restAPICall(
      Constants.MANAGER_URL + "/stone",
      "get",
      Constants.userToken,
      params,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetMultipleStone = (customerId, stone, callback) => {
    restAPICall(
      Constants.MANAGER_URL + `/stone/multiple/${customerId}`,
      "post",
      Constants.userToken,
      undefined,
      JSON.stringify(stone),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static CheckStoneAvailable = (stone, callback) => {
    let params = {
      stone: stone,
    };

    restAPICall(
      Constants.MANAGER_URL + "/stone/available",
      "get",
      Constants.userToken,
      params,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static AddStone = (stone, callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/stone",
      "post",
      Constants.userToken,
      undefined,
      JSON.stringify(stone),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static UpdateStone = (stone, callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/stone",
      "put",
      Constants.userToken,
      undefined,
      JSON.stringify(stone),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetFilteredStock = (data, callback) => {
    restAPICall(
      Constants.MANAGER_URL + `/stone/stock/query`,
      "post",
      Constants.userToken,
      undefined,
      JSON.stringify(data),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetStoneAsOnDate = (date, data, callback) => {
    let params = {
      date: date
    }
    restAPICall(
      Constants.MANAGER_URL + `/stone/stock/ondate`,
      "post",
      Constants.userToken,
      params,
      JSON.stringify(data),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetFilteredStockSearch = (
    userId,
    customerId,
    data,
    callback
  ) => {
    restAPICall(
      Constants.MANAGER_URL +
      `/stone/stock/query/${userId}/${customerId}`,
      "post",
      Constants.userToken,
      undefined,
      JSON.stringify(data),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static CreateMemo = (data, usertype, callback) => {
    restAPICall(
      Constants.MANAGER_URL + `/memo/${usertype}`,
      "post",
      Constants.userToken,
      undefined,
      JSON.stringify(data),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetSingleStoneDetail = (stoneId, category, callback) => {
    let params = {
      stoneid: stoneId,
      category: category
    };

    restAPICall(
      Constants.MANAGER_URL + "/stonedetail",
      "get",
      Constants.userToken,
      params,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetMultipleStoneDetails = (category, data, callback) => {
    let params = {
      category: category
    };

    restAPICall(
      Constants.MANAGER_URL +
      "/stonedetail/multiplestonedetails",
      "post",
      Constants.userToken,
      category ? params : undefined,
      JSON.stringify(data),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static UploadStones = (file, type, callback) => {
    restAPICall(
      Constants.WORKER_URL + `/upload/stone/${type}`,
      "post",
      Constants.userToken,
      undefined,
      file,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static SellStones = (data, callback) => {
    restAPICall(
      Constants.MANAGER_URL + `/stone/sell`,
      "post",
      Constants.userToken,
      undefined,
      JSON.stringify(data),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static CreatePerforma = (data, callback) => {
    restAPICall(
      Constants.MANAGER_URL + `/stone/sell/performa`,
      "post",
      Constants.userToken,
      undefined,
      JSON.stringify(data),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static UpdatePerforma = (data, callback) => {
    restAPICall(
      Constants.MANAGER_URL + `/stone/sell/update/performa`,
      "put",
      Constants.userToken,
      undefined,
      JSON.stringify(data),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static UpdatePerformaToInvoice = (data, callback) => {
    restAPICall(
      Constants.MANAGER_URL + `/stone/sell/update/performatoinvoice`,
      "post",
      Constants.userToken,
      undefined,
      JSON.stringify(data),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetAllStonesForAvailable = (userId, callback) => {
    restAPICall(
      Constants.MANAGER_URL +
      `/stone/availableforapproval/${userId}`,
      "get",
      Constants.userToken,
      undefined,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetAllStonesForAvailableByLocation = (userId, locationid, callback) => {
    restAPICall(
      Constants.MANAGER_URL +
      `/stone/availableforapproval/${userId}/${locationid}`,
      "get",
      Constants.userToken,
      undefined,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static SellStonesInvoice = (data, callback) => {
    restAPICall(
      Constants.MANAGER_URL + `/stone/sell/invoice`,
      "post",
      Constants.userToken,
      undefined,
      JSON.stringify(data),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static CreateOffer = (data, usertype, callback) => {
    restAPICall(
      Constants.MANAGER_URL + `/offer/${usertype}`,
      "post",
      Constants.userToken,
      undefined,
      JSON.stringify(data),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };
  static MarkStoneAvailable = (data, callback) => {
    restAPICall(
      Constants.MANAGER_URL + `/stone/availableforapproval`,
      "put",
      Constants.userToken,
      undefined,
      JSON.stringify(data),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetAllHoldStone = (
    usertype,
    userid,
    selectedCustomer,
    stonetype,
    callback) => {
    let params = { selectedCustomer: selectedCustomer };
    restAPICall(
      Constants.MANAGER_URL + `/stone/myhold/${userid}/${usertype}/detail`,
      "post",
      Constants.userToken,
      params,
      stonetype,
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static HoldStones = (data, usertype, callback) => {
    restAPICall(
      Constants.MANAGER_URL + `/stone/hold/${usertype}`,
      "post",
      Constants.userToken,
      undefined,
      JSON.stringify(data),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static ReleaseStones = (data, callback) => {
    restAPICall(
      Constants.MANAGER_URL + `/stone/releasehold`,
      "post",
      Constants.userToken,
      undefined,
      JSON.stringify(data),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static AddStockSearchCriteria = (
    userId,
    stockData,
    callback
  ) => {
    let params = {
      userid: userId,
    };
    restAPICall(
      Constants.MANAGER_URL + "/usersetting/setstocksearch",
      "post",
      Constants.userToken,
      params,
      JSON.stringify(stockData),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetSingleUserStockSearchCriteria = (userId, callback) => {
    let params = {
      userid: userId,
    };

    restAPICall(
      Constants.MANAGER_URL + "/usersetting/getstocksearch",
      "get",
      Constants.userToken,
      params,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetAllInvoices = (userType, data, callback) => {
    restAPICall(
      Constants.MANAGER_URL + `/stone/sales/${userType}`,
      "post",
      Constants.userToken,
      undefined,
      JSON.stringify(data),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static CancelSale = (data, callback) => {
    restAPICall(
      Constants.MANAGER_URL + `/stone/cancelsell`,
      "post",
      Constants.userToken,
      undefined,
      JSON.stringify(data),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static CancelMixSale = (invoiceid, callback) => {
    restAPICall(
      Constants.MANAGER_URL + `/stone/cancelmixsell/${invoiceid}`,
      "post",
      Constants.userToken,
      undefined,
      undefined,
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetLatestProformaDetail = (customerid, callback) => {
    restAPICall(
      Constants.MANAGER_URL + `/stone/sell/latestproforma/${customerid}`,
      "get",
      Constants.userToken,
      undefined,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetStoneByStatus = (status, callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/stone/status",
      "post",
      Constants.userToken,
      undefined,
      JSON.stringify(status),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GenerateCriteriaLink = (data, callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/criterialink",
      "post",
      Constants.userToken,
      undefined,
      JSON.stringify(data),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetCriteriaByGUID = (guid, callback) => {
    restAPICall(
      Constants.MANAGER_URL + `/criterialink/${guid}`,
      "get",
      Constants.userToken,
      undefined,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static UpdateStoneStatus = (data, status, callback) => {
    restAPICall(
      Constants.MANAGER_URL + `/stone/updatestatus/${status}`,
      "put",
      Constants.userToken,
      undefined,
      JSON.stringify(data),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static sendHoldStoneCustomerEmployeeNotification = (userid, customerid, data, callback) => {
    let params = {
      userid: userid,
      customerid: customerid
    };
    restAPICall(
      Constants.MANAGER_URL + "/stone/employee/notification",
      "post",
      Constants.userToken,
      params,
      JSON.stringify(data),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GenerateCriteriaLinkForWolzaDataStoneIds = (employeeid, data, callback) => {
    restAPICall(
      Constants.MANAGER_URL + `/criterialink/wolza/${employeeid}/stoneids`,
      "post",
      Constants.userToken,
      undefined,
      JSON.stringify(data),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static MarkStoneStatusToOffline = (data, callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/stone/offline",
      "post",
      Constants.userToken,
      undefined,
      JSON.stringify(data),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static MarkStoneStatusToAvailable = (data, callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/stone/online",
      "post",
      Constants.userToken,
      undefined,
      JSON.stringify(data),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetStoneDetailByConsignmentNo = (consignmentno, callback) => {
    restAPICall(
      Constants.MANAGER_URL +
      `/stone/byconsignmentno/${consignmentno}`,
      "get",
      Constants.userToken,
      undefined,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetAllConsignmentNo = (callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/stone/consignmentno",
      "get",
      Constants.userToken,
      undefined,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetProformaByStoneid = (stoneid, callback) => {
    restAPICall(
      Constants.MANAGER_URL + `/stone/stonedetail/proforma/${stoneid}`,
      "get",
      Constants.userToken,
      undefined,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetInvoiceByStoneid = (stoneid, callback) => {
    restAPICall(
      Constants.MANAGER_URL + `/stone/stonedetail/invoice/${stoneid}`,
      "get",
      Constants.userToken,
      undefined,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetProformaPDF = (data, callback) => {
    restAPICall(
      Constants.MANAGER_URL + `/stone/sell/performa/pdf`,
      "post",
      Constants.userToken,
      undefined,
      JSON.stringify(data),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetStoneIdByTagId = (tagids, callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/stone/tag",
      "post",
      Constants.userToken,
      undefined,
      JSON.stringify(tagids),
      "application/json",
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  }
}
